/**
 * ObjectUtil
 */

class ObjectUtil {

  /**
   * @param {object} obj - 복사할 object
   * @return {object} 복사된 object
   */
  static clone( obj ) {

    if ( null === obj || 'object' !== typeof obj ) {
    	return obj;
    }

    const _clone = obj.constructor();
    // copy = { ...obj };

    for ( const attr in obj ) {
    	if ( obj.hasOwnProperty( attr ) ) {
    		copy[ attr ] = obj[ attr ];
    	}
    }

    return _clone;
  }

  /**
   * @param {function} func - cache할 function
   * @return {object} function 실행 결과
   */
  static cacheDecorator( func ) {
    const _cache = {};

    return ( value ) => {

      if ( _cache[ value ] ) {
        return _cache[ value ];
      }

      const result = func( value );

      _cache[ value ] = result;

      return result;
    };
  }
}

export default ObjectUtil;
